module.exports = __webpack_public_path__ + "img/ellipse-02.e79b8a55.png";